const SvgData4 = (props) => (
  <>
    <path
      d="M0 96c26.51 0 48-21.49 48-48S26.51 0 0 0v96ZM48 0c26.51 0 48 21.49 48 48S74.51 96 48 96V0Z"
      fill={props.p40}
    />
  </>
);

export default SvgData4;
